import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { useInView } from 'react-intersection-observer'
import { useStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const FocusField = ({ name, label, helperHeading }) => {
  const classes = useStyles()
  const { register, errors } = useFormContext()
  const fieldErrors = errors?.golfFocusInformation ?? {}
  const fieldName = name.split('.').pop()
  const { ref, inView } = useInView({ triggerOnce: true })

  useEffect(() => {
    if (inView) {
      // Rerender multiline field once in view so rows expand correctly.
    }
  }, [inView])

  return (
    <Box className={classes.fieldGroup} ref={ref}>
      <Typography className={classes.sectionHeading}>
        {helperHeading}
      </Typography>
      <TextField
        name={name}
        inputRef={register}
        multiline
        minRows={4}
        error={!!fieldErrors?.[fieldName]}
        helperText={fieldErrors?.[fieldName]?.message}
        label={label}
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
        id={name.split('.').join('-')}
      />
    </Box>
  )
}

const GolfFocusInformation = () => {
  const classes = useStyles()

  return (
    <Box>
      <Typography className={classes.sectionHeading}>
        Game improvement
      </Typography>
      <FocusField
        name="golfFocusInformation.confidentArea"
        helperHeading="What part of your game are you most confident in?"
        label="e.g., your swing, your putting"
      />
      <FocusField
        name="golfFocusInformation.improvementArea"
        helperHeading="What part of your game would you like to see improve?"
        label="e.g., your swing, your putting"
      />
    </Box>
  )
}

export default GolfFocusInformation
